import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
} from "react-native";
import React, { useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import { RootState, dispatch, useSelector } from "../../../../../redux/store";
import { getExperience } from "../../../../../services/ProfileSettings/ProfileSettingService";
import { setExperienceHook } from "../../../../../redux/profile/profileSlice";
import editProfileStyle from "../../../styles/editProfileStyle";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import styles from "../../../styles/styles";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import ExperienceAlert from "../../../../../modal/OnBoardingModal/ExperienceAlert";

export default function EditExperience({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  // console.log(route);
  
  const { staticData, setStaticData ,exprienceArrayId,setExprienceArrayId } = route?.params;
  // console.log("====================================");
  // console.log("staticData in route", staticData);
  // console.log("====================================");
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);
  const [alertOpen,setAlertOpen]=useState(false)

  function uploadButtonHandle(id: any) {
    if (image1 == id) {
      setImage1(image2);
      setImage2(image3);
      setImage3(null);
    } else if (image2 == id) {
      setImage2(image3);
      setImage3(null);
    } else if (image3 == id) {
      setImage3(null);
    } else if (image1 == null) {
      setImage1(id);
    } else if (image2 == null) {
      setImage2(id);
    } else if (image3 == null) {
      setImage3(id);
    }
    else{
      setAlertOpen(true)
    }
  }
  const findcount = (id: any) => {
    if (id == image1) {
      return 1;
    } else if (id == image2) {
      return 2;
    } else if (id == image3) {
      return 3;
    }
    
  };
  const [data, setData] = useState(null);
  let profile = useSelector((state: RootState) => state.profile);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getExperience();
        // const jsonData = await response.json();
        setData(response);
        // console.log(jsonData.experiences[0])
      } catch (error) {
        console.error(error);
      }
    };
    const setExperience = async () => {
      let list = staticData?.interestedExperiences;
      if (list[0] != null) {
        setImage1(list[0].id);
      }
      if (list[1] != null) {
        setImage2(list[1].id);
      }
      if (list[2] != null) {
        setImage3(list[2].id);
      }
    };

    fetchData();
    setExperience();
  }, []); // T

  useEffect(() => {
    // console.log('change')
    let update: any[] = [];
    if (image1) {
      update.push({ id: image1 });
    }
    if (image2) {
      update.push({ id: image2 });
    }

    if (image3) {
      update.push({ id: image3 });
    }
    setExprienceArrayId(update)
    setStaticData((prev: any) => {
      return {
        ...prev,
        interestedExperiences: update,
      };
      
    });
   
  }, [image1, image2, image3]);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex",
        alignItems: "center", 
        height: "100%",
      }}
    >
      <ExperienceAlert isVisible={alertOpen} toggleModal={()=>{setAlertOpen(!alertOpen)}} />
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, {  }]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              {/* <Image source={Icons.Back} /> */}
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Experience</Text>
          </View>
        </View>
      </View>
      <ScrollView
        style={{ backgroundColor: "white", width: "100%", height: "100%", paddingHorizontal: 20 }}
        showsVerticalScrollIndicator={false}
      >
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: 'center'
          }}
        >
          {data?.experiences.map((experience: any, index: any) => {
            return (
              <View
                style={[
                  styles.innerUploadMain,
                  {
                    marginTop: 24,
                  },
                ]}
                key={index}
              >
                {image1 == experience._id ||
                image2 == experience._id ||
                image3 == experience._id ? (
                  <TouchableOpacity
                    onPress={() => uploadButtonHandle(experience._id)}
                  >
                    <View
                      style={[
                        styles.imageBox1,
                        {
                          display: "flex",
                          flexWrap: "wrap",
                          flexDirection: "row",
                        },
                      ]}
                    >
                      <Image
                        style={{
                          height: 180,
                          width: "100%",
                          borderRadius: 10,
                          objectFit: "cover",
                        }}
                        source={{ uri: experience.media.images[0].url }}
                        blurRadius={3}
                      />
                      <Text
                        style={[
                          GlobalStyles.black90,
                          GlobalStyles.captionText,
                          {
                            fontSize: 16,
                            marginTop: 4,
                            marginLeft: 7,
                            fontFamily: "EBGaramondRegular",
                          },
                        ]}
                      >
                        {experience.title}
                      </Text>
                    </View>
                    <View style={styles.blurBoxText}>
                      <Text style={styles.blurText}>
                        {findcount(experience._id)}
                      </Text>
                    </View>
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity
                    onPress={() => uploadButtonHandle(experience._id)}
                  >
                    <View
                      style={[
                        styles.imageBox1,
                        {
                          display: "flex",
                          flexWrap: "wrap",
                          flexDirection: "row",
                        },
                      ]}
                    >
                      <Image
                        style={{
                          height: 180,
                          width: "100%",
                          borderRadius: 10,
                        }}
                        source={{ uri: experience.media.images[0].url }}
                      />
                      <Text
                        style={[
                          GlobalStyles.black90,
                          GlobalStyles.captionText,
                          {
                            fontSize: 16,
                            marginTop: 4,
                            marginLeft: 7,
                            fontFamily: "EBGaramondRegular",
                          },
                        ]}
                      >
                        {experience.title}
                      </Text>
                    </View>
                  </TouchableOpacity>
                )}
              </View>
            );
          })}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
